import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// import isAuthenticated from '../services/auth';
import { PrecheckContext } from '../contexts/PrecheckContext';

const ProtectedRoute = () => {
    const orgCode = localStorage.getItem('orgCode');
    const { isAuthenticated } = useContext(PrecheckContext);

    // Since authentication is no longer required for the app, we can just return the Outlet component

    // return isAuthenticated ? <Outlet /> : <Navigate to={`/?org=${orgCode}`} />;
    return <Outlet />;
};

export default ProtectedRoute;
